import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";

import Home from "@/pages/Home";
import Auth from "@/pages/Auth";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import FindPeople from "@/pages/FindPeople";
import PublicProfile from "@/pages/PublicProfile";
import HowItWorks from "@/pages/HowItWorks";
import CandidateDashboard from "@/pages/CandidateDashboard";
import CandidateProfile from "@/pages/CandidateProfile";
import EmployerDashboard from "@/pages/EmployerDashboard";
import PostJob from "@/pages/PostJob";
import AdminDashboard from "@/pages/AdminDashboard";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex min-h-screen items-center justify-center text-navy">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/signup" element={<Auth mode="signup" />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/jobs/:id" element={<JobDetail />} />
            <Route path="/find-people" element={<FindPeople />} />
            <Route path="/u/:slug" element={<PublicProfile />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/dashboard" element={<Protected roles={["candidate"]}><CandidateDashboard /></Protected>} />
            <Route path="/profile" element={<Protected roles={["candidate"]}><CandidateProfile /></Protected>} />
            <Route path="/employer" element={<Protected roles={["employer"]}><EmployerDashboard /></Protected>} />
            <Route path="/employer/post-job" element={<Protected roles={["employer"]}><PostJob /></Protected>} />
            <Route path="/admin" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
